var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 30,
    viewBox: "0 0 25 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#1C1B1A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.4 0C11.084 0 10 1.084 10 2.4v1.113C5.858 4.577 2.8 8.324 2.8 12.8V20C1.263 20 0 21.263 0 22.8s1.263 2.8 2.8 2.8h6.8v.4c0 1.537 1.263 2.8 2.8 2.8s2.8-1.263 2.8-2.8v-.4H22c1.537 0 2.8-1.263 2.8-2.8S23.537 20 22 20v-7.2c0-4.476-3.058-8.223-7.2-9.287V2.4c0-1.316-1.084-2.4-2.4-2.4zm0 1.6c.457 0 .8.343.8.8v.838c-.262-.022-.532-.038-.8-.038s-.538.016-.8.038V2.4c0-.457.343-.8.8-.8zm0 3.2c4.446 0 8 3.554 8 8V20h-16v-7.2c0-4.446 3.554-8 8-8zM2.8 21.6H22c.679 0 1.2.521 1.2 1.2 0 .679-.521 1.2-1.2 1.2H2.8c-.679 0-1.2-.521-1.2-1.2 0-.679.521-1.2 1.2-1.2zm8.4 4h2.4v.4c0 .679-.521 1.2-1.2 1.2-.679 0-1.2-.521-1.2-1.2v-.4z",
    transform: "translate(-1381.000000, -28.000000) translate(1381.000000, 28.000000) translate(0.000000, 0.255128)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.a5aa96ae62365ded970d7e720f276d28.svg";
export { ForwardRef as ReactComponent };